import { graphqlRequest } from "../../services/apiService";

export const allCompanyCount = async () => {
  try {
    const query = `
      query GetAllCompanyCount {
        getAllCompanyCount {
          success
          data
        }
      }
    `;

    const data = await graphqlRequest(query, {});
    return data.getAllCompanyCount;
  } catch (error) {
    console.error("Error fetching company count:", error);
    throw error;
  }
};
